import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ChangeFocusDirective } from 'app/shared/directives/change-focus.directive';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './components/app/app.component';
import { NavMenuComponent } from './components/navmenu/navmenu.component';
import { CommonDataService } from 'app/services/common-data.service';
import { LoginService } from 'app/services/login.service';
import { SharedModule } from 'app/shared/shared.module';
import { BufferGraphModule } from 'app/buffer-graph/buffer-graph.module';
import { SaveUserPropService } from "app/services/save-user-prop";
import { CheckVersions } from "app/services/check-versions.service";
import {CommonService} from "./services/common.service";

export function translateLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http);
}

@NgModule({
    declarations: [
        AppComponent,
        NavMenuComponent
    ],
    imports: [
        BrowserModule,
        FormsModule,
        HttpClientModule,
        AppRoutingModule,
        SharedModule.forRoot(),
        BufferGraphModule.forRoot(),
        TranslateModule.forRoot({
            loader: { provide: TranslateLoader, useFactory: translateLoaderFactory, deps: [HttpClient] }
        })
    ],
    providers: [LoginService],
    bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts